import { render, staticRenderFns } from "./AssignSimpleRelationField.vue?vue&type=template&id=7163dd5a&scoped=true"
import script from "./AssignSimpleRelationField.vue?vue&type=script&lang=js"
export * from "./AssignSimpleRelationField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7163dd5a",
  null
  
)

export default component.exports